<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Client Campaign Steps</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="editClientCampaignStep"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            >
          </vs-col>
        </vs-row>
                <vs-divider class="m-5" />
                        <div class="vx-row p-5" v-if="clientCampaignStepDescription.client_id">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Client:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientCampaignStepDescription.company_name }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="clientCampaignStepDescription.steps">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Step:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientCampaignStepDescription.steps }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="clientCampaignStepDescription.description">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
             Description:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientCampaignStepDescription.description }}
          </div>
        </div>
                <div class="vx-row p-5" v-if="clientCampaignStepDescription.phase">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Phase:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientCampaignStepDescription.phase }}
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import _ from "lodash";
import moduleStepsManagement from "@/store/campaign-management/client-campaign-steps-management/moduleStepsManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

      clientCampaignStepDescription: [],
      stepId: null,
    };
  },
  components: {
    "v-select": vSelect,
    moduleStepsManagement
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });   
    if (!moduleStepsManagement.isRegistered) {
      this.$store.registerModule(
        "StepsManagement",
        moduleStepsManagement
      );
      moduleStepsManagement.isRegistered = true;
    }
  },
  mounted() {
        this.stepId = this.$route.params.stepId;
        this.fetchClientCampaignStep()
  },
  methods: {
      goBack: function() {
      this.$router.go(-1);
    },
    fetchClientCampaignStep() {
    this.$store
        .dispatch("StepsManagement/fetchSteps", this.stepId)
        .then(res => {
          this.clientCampaignStepDescription = JSON.parse(res.data);
          console.log(this.clientCampaignStepDescription)
        })
        .catch(err => {
          console.error(err);
        });
    },
    editClientCampaignStep() {
      this.$router.push({ path: `/campaigns/client-campaign-step/edit/${this.stepId}` });
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
